import { TipologiaSoggettoResponsabile } from './tipologia-soggetto-responsabile';

export class SoggettoResponsabile{
    id:number;
    tipologia:TipologiaSoggettoResponsabile;
    nome:string;
    cognome:string;
    email:string;
}